var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TransactionExportPageAdmin',{attrs:{"TE":_vm.TE},on:{"import":_vm.importTransaction,"export":_vm.exportTransaction}})
}
var staticRenderFns = []

export { render, staticRenderFns }